import Vue from 'vue'

export function is_null(d) {
	if (typeof d === 'undefined') return true

	if (typeof d === 'string') {
		//字符串
		if (d === 'undefined' || d === '') {
			return true
		} else {
			return false
		}
	}

	if (Array.isArray(d)) {
		//数组
		if (d.length == 0) {
			return true
		} else {
			return false
		}
	}

	return false
}

// 空判断
export function inputNullCheck(val, prompt) {
	if (is_null(val)) {
		Vue.$vux.toast.show({
			text: prompt + '不能为空',
			type: 'cancel'
		})
		return true
	}
	return false
}

export function inputArrayNullCheck(array) {
	if (!array || Object.prototype.toString.call(array) !== '[object Array]' || array.length === 0) {
		console.error('工具函数(inputArrayNullCheck): 参数不存在或参数类型错误!')
		return
	}

	for (var i = 0; i < array.length; i++) {
		if (Object.prototype.toString.call(array[i]) !== '[object Object]') break
		if (inputNullCheck(array[i].value, array[i].prompt)) return true
	}

	return false
}

// 时间格式转换
export function dateFormat(type, val) {
	const date = new Date() || val
	let result
	if (type === 'yyyy-mm-dd') {
		result = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate())
	} else {
		result =
			date.getFullYear() +
			'-' +
			pad(date.getMonth() + 1) +
			'-' +
			pad(date.getDate()) +
			' ' +
			pad(date.getHours()) +
			':' +
			pad(date.getMinutes()) +
			':' +
			pad(date.getSeconds())
	}
	return result
}

// 检测数字是 个位 还是 十位
export function pad(val, len) {
	val = String(val)
	len = len || 2
	while (val.length < len) {
		val = '0' + val
	}
	return val
}

// 转化 路由 component 对象
export function lazyLoading(url) {
    // return () => import(`@/${url}.vue`)
    return (resolve) => require([`@/${url}.vue`], resolve)

}

// 取地址栏参数
export function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
        return {}
    }
    return JSON.parse(
        '{"' +
        decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
        '"}'
    )
}

// 数据去除空格
export function spaceFilter(data) {
	return data.replace(/\s+/g, '')
}

// 深拷贝
export function deepCopy(source, type) {
	let stringify = JSON.stringify(source)
	return JSON.parse(stringify)
}

// 数组去重
export function unique(arr, type, ele) {
	let backArr = []
	// 纯数组
	if (type === 'Array' || type === undefined) {
		arr.map(item => {
			backArr.indexOf(item) === -1 ? backArr.push(item) : ''
		})
	}

	// 对象数组去重
	if (type === 'Object') {
		arr.map((item, index) => {
			let _index = arr.findIndex(x => x[ele] === item[ele])
			_index === index ? backArr.push(item) : ''
		})
	}

	// 自传去重方法 (默认 纯数字数组)
	if (type === 'Function') {
		arr.map((item, index) => {
			let b = ele.call(arr, item, index)
			// backArr.push(b)
			backArr.indexOf(b) === -1 ? backArr.push(b) : ''
		})
	}

	return backArr
}

// 预览公共方法
export function previewFn(previewUrl, fileName) {
	// 预览地址 拼接预览前缀
	let _previewUrl = process.env.VUE_APP_PREVIEW_URL + previewUrl

	bmStorage.localStorage.set('previewUrl', _previewUrl)
	bmStorage.localStorage.set('fileName', fileName)
	let url = `${window.location.origin}${window.location.pathname}#/preview-online`
	return window.open(url, '_blank')
}

// 随机数生成（包含字母和数字）
export function generateRandomString() {
	// 定义包含所有可能字符的集合：0-9数字和A-Z大写字母
	const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
	let result = ''
	const length = 5

	for (let i = 0; i < length; i++) {
		// 生成0到字符集长度之间的随机索引
		const randomIndex = Math.floor(Math.random() * characters.length)
		// 从字符集中选取对应索引的字符并拼接到结果中
		result += characters.charAt(randomIndex)
	}

	return result
}

/**
 * 下载文件（兼容低版本 Node.js）
 * @param url 下载资源地址（支持跨域需后端配置 CORS）
 * @param fileName 自定义下载文件名（含后缀，如 "报告.xlsx"）
 * @param options 下载配置项（可选）
 * @returns 返回 XMLHttpRequest 实例，支持中断下载（xhr.abort()）
 */
export function downloadFile(url, fileName, options = {}) {
	// 1. 参数合法性校验（替换 ?. 为 条件判断 + 函数调用）
	if (!url || typeof url !== 'string') {
		const errorMsg = '下载失败：请传入有效的资源地址（url）'
		// 修复：判断 onError 存在才调用，避免低版本环境报错
		if (options.onError && typeof options.onError === 'function') {
			options.onError(errorMsg)
		}
		throw new Error(errorMsg)
	}
	if (!fileName || typeof fileName !== 'string') {
		const errorMsg = '下载失败：请传入有效的文件名（含后缀，如 "文件.pdf"）'
		if (options.onError && typeof options.onError === 'function') {
			options.onError(errorMsg)
		}
		throw new Error(errorMsg)
	}

	// 2. 创建 XHR 实例
	const xhr = new XMLHttpRequest()
	xhr.open('GET', url, true)

	// 3. 配置请求（响应类型、请求头）
	xhr.responseType = 'blob'
	if (options.headers && typeof options.headers === 'object') {
		Object.entries(options.headers).forEach(([key, value]) => {
			xhr.setRequestHeader(key, value)
		})
	}

	// 4. 下载进度监听（替换 ?. 为 条件判断）
	xhr.onprogress = function (e) {
		if (e.lengthComputable) {
			const progress = Math.round((e.loaded / e.total) * 100)
			// 修复：判断 onProgress 存在且是函数才调用
			if (options.onProgress && typeof options.onProgress === 'function') {
				options.onProgress(progress)
			}
		}
	}

	// 5. 下载成功处理
	xhr.onload = function () {
		if (xhr.status >= 200 && xhr.status < 300) {
			const blob = xhr.response
			if (window.navigator.msSaveBlob) {
				// 兼容 IE
				window.navigator.msSaveBlob(blob, fileName)
			} else {
				const blobUrl = window.URL.createObjectURL(blob)
				const a = document.createElement('a')
				a.style.display = 'none'
				a.href = blobUrl
				a.download = fileName

				document.body.appendChild(a)
				a.click()

				// 清理资源
				document.body.removeChild(a)
				window.URL.revokeObjectURL(blobUrl)
			}
			// 修复：判断 onSuccess 存在且是函数才调用
			if (options.onSuccess && typeof options.onSuccess === 'function') {
				options.onSuccess()
			}
		} else {
			const errorMsg = `下载失败：HTTP 状态码 ${xhr.status}（${url}）`
			if (options.onError && typeof options.onError === 'function') {
				options.onError(errorMsg)
			}
			throw new Error(errorMsg)
		}
	}

	// 6. 错误处理（网络错误、超时）
	xhr.onerror = function () {
		const errorMsg = `下载失败：网络错误或资源不可达（${url}）`
		if (options.onError && typeof options.onError === 'function') {
			options.onError(errorMsg)
		}
		throw new Error(errorMsg)
	}

	xhr.ontimeout = function () {
		const errorMsg = `下载失败：请求超时（${url}）`
		if (options.onError && typeof options.onError === 'function') {
			options.onError(errorMsg)
		}
		throw new Error(errorMsg)
	}

	// 7. 发送请求
	xhr.send()

	return xhr
}



// WEBPACK FOOTER //
// ./src/utility/tools.js